"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "badia-tedalda": {
    "5c23447c": [{
      "hkey": "e93f67bc",
      "slug": "badia-tedalda",
      "name": "Badia Tedalda",
      "primary": true,
      "skipSearch": false
    }],
    "cicognaia": [{
      "hkey": "e93f67bc",
      "slug": "badia-tedalda",
      "name": "Badia Tedalda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bbd8e8c0": [{
      "hkey": "e93f67bc",
      "slug": "badia-tedalda",
      "name": "Badia Tedalda",
      "primary": true,
      "skipSearch": false
    }],
    "montelabreve": [{
      "hkey": "e93f67bc",
      "slug": "badia-tedalda",
      "name": "Badia Tedalda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d398eb85": [{
      "hkey": "e93f67bc",
      "slug": "badia-tedalda",
      "name": "Badia Tedalda",
      "primary": true,
      "skipSearch": false
    }],
    "ranco": [{
      "hkey": "e93f67bc",
      "slug": "badia-tedalda",
      "name": "Badia Tedalda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "34f1290b": [{
      "hkey": "e93f67bc",
      "slug": "badia-tedalda",
      "name": "Badia Tedalda",
      "primary": true,
      "skipSearch": false
    }],
    "san-patrignano": [{
      "hkey": "e93f67bc",
      "slug": "badia-tedalda",
      "name": "Badia Tedalda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7762dd6d": [{
      "hkey": "e93f67bc",
      "slug": "badia-tedalda",
      "name": "Badia Tedalda",
      "primary": true,
      "skipSearch": false
    }],
    "stiavola": [{
      "hkey": "e93f67bc",
      "slug": "badia-tedalda",
      "name": "Badia Tedalda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cde4e9a1": [{
      "hkey": "1f6850f1",
      "slug": "viamaggio",
      "name": "Viamaggio",
      "primary": true,
      "skipSearch": false
    }],
    "via-maggio": [{
      "hkey": "1f6850f1",
      "slug": "viamaggio",
      "name": "Viamaggio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;